module.exports = __webpack_public_path__ + "static/media/shop.1c791e50.png";